<script lang="ts">
  import { onDestroy } from "svelte";
  import { t } from "$lib/utils/i18n";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";

  interface Props {
    error: Error;
  }
  let { error }: Props = $props();
  const config = getConfigurationContext();

  const reloadDelay =
    Number(import.meta.env.VITE_RELOAD_ON_ERROR_DELAY_MS) || 5000;
  const timeout = setTimeout(() => {
    window.location.reload();
  }, reloadDelay);

  onDestroy(() => {
    clearTimeout(timeout);
  });
</script>

<article class="h-full flex flex-col justify-center p-8">
  <p class="text-xl my-2">
    {t("error.reloading", config.language).replace("{seconds}", String(reloadDelay / 1000))}
  </p>
  <code class="bg-gray-200 p-4 mx-2">{error.message}</code>
</article>
